/*
    This file has to be imported so all component registrations can take place
*/
import './DisplayDate.vue';
import './SecondaryButton.vue';
import './TypeSwitcher.vue';
import './Table.vue';
import './AutoCompleteInput';
import './ExpandableList';
import './Barcode';
import './VideoPlayer';
import './forms/CustomInput';
import './forms/CustomFileInput';
import './forms/CustomCheckbox';
import './forms/NumberInput';
import './forms/CustomSelect';
import './forms/GenericForm';
import './tree/Tree';
import './Password';
import './StaticLink';
import './ExternalLink';
import './AppHealthChecker';
import './MaintenanceChecker';
import './accordion/Accordion';
import './accordion/AccordionItem';
import './AppReadyChecker';
// import './CarouselComponent'; bring back if needed
import './StaticImage';
import './Button';
import './map/GoogleMap';
import './Timer.vue';
import './SectionHeader.vue';
import './SubtleLink.vue';
import './SubtleLinkExternal.vue';
import './BackContainer.vue';
import './TaxLimitsSummary.vue';
import './Tooltip.vue';
import './FlagIcon.vue';
import './Illustration.vue';
import './SpinnerBars.vue';
import './PrivacyConsentGeneralInfo.vue';
import './PrivacyConsentCustomInfo.vue';
import './PrivacyConsentWithdrawalInfo.vue';
import './TermsAndConditions.vue';
// uncomment when needed. Won't go into the bundle while commented
// import './VisibilityIndicator';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/modules/shared/components/index.ts